module.exports = __webpack_public_path__ + "img/icon_eka.68c5758e.png";